export const csrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

export const postJson = (url, body) =>
  fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken(),
    },
    body: JSON.stringify(body),
  });

export const postTurboStream = (url, body) =>
  fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/vnd.turbo-stream.html',
      'X-CSRF-Token': csrfToken(),
    },
    body: JSON.stringify(body),
  });
